import './sass/app.scss'
import WordPress from '&/class/WordPress';

const wordpress = new WordPress()

// wordpress.enableLocomotive()
wordpress.init()
